import { GenIcon } from '../helpers/IconBase.es.js';

const HomeLocationColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_17546)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M16 6.48252V12.6665C15.9989 13.5503 15.6474 14.3975 15.0225 15.0224C14.3976 15.6473 13.5504 15.9988 12.6667 15.9999H12C11.8232 15.9999 11.6536 15.9296 11.5286 15.8046C11.4036 15.6796 11.3333 15.51 11.3333 15.3332C11.3333 15.1564 11.4036 14.9868 11.5286 14.8618C11.6536 14.7368 11.8232 14.6665 12 14.6665H12.6667C13.1971 14.6665 13.7058 14.4558 14.0809 14.0807C14.456 13.7057 14.6667 13.197 14.6667 12.6665V6.48252C14.6667 6.15514 14.5863 5.83275 14.4327 5.54366C14.279 5.25458 14.0567 5.00764 13.7853 4.82452L9.11867 1.67586C8.78892 1.45106 8.39909 1.33083 8 1.33083C7.60092 1.33083 7.21109 1.45106 6.88134 1.67586L2.21467 4.82452C1.94328 5.00764 1.721 5.25458 1.56733 5.54366C1.41367 5.83275 1.33332 6.15514 1.33334 6.48252V12.6665C1.33334 13.197 1.54405 13.7057 1.91912 14.0807C2.2942 14.4558 2.8029 14.6665 3.33334 14.6665H4C4.17681 14.6665 4.34638 14.7368 4.47141 14.8618C4.59643 14.9868 4.66667 15.1564 4.66667 15.3332C4.66667 15.51 4.59643 15.6796 4.47141 15.8046C4.34638 15.9296 4.17681 15.9999 4 15.9999H3.33334C2.44961 15.9988 1.60237 15.6473 0.977483 15.0224C0.352591 14.3975 0.00106118 13.5503 2.61138e-06 12.6665V6.48252C-0.000680639 5.937 0.132722 5.39967 0.388472 4.91782C0.644222 4.43596 1.01448 4.02434 1.46667 3.71919L6.13334 0.569856C6.68351 0.196491 7.3331 -0.00311279 7.998 -0.00311279C8.6629 -0.00311279 9.3125 0.196491 9.86267 0.569856L14.5293 3.71919C14.982 4.02419 15.3528 4.43566 15.6092 4.91748C15.8656 5.3993 15.9998 5.93672 16 6.48252Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.314 11.7911C12.5486 11.2248 12.6685 10.6175 12.6668 10.0045C12.6669 9.23675 12.4775 8.48084 12.1155 7.80379C11.7535 7.12673 11.23 6.54945 10.5915 6.12312C9.95299 5.69679 9.21916 5.43459 8.45505 5.35975C7.69095 5.28491 6.92018 5.39975 6.21109 5.69409C5.50199 5.98843 4.87646 6.45317 4.38997 7.04712C3.90347 7.64107 3.57103 8.34588 3.42212 9.09906C3.2732 9.85224 3.31242 10.6305 3.53629 11.3649C3.76016 12.0993 4.16176 12.7671 4.7055 13.3092L7.0435 15.5958C7.30003 15.8442 7.6431 15.9831 8.00016 15.9831C8.35723 15.9831 8.7003 15.8442 8.95683 15.5958L11.3002 13.3038C11.7348 12.8716 12.0794 12.3574 12.314 11.7911ZM11.3335 10.0045C11.3335 9.45636 11.1983 8.91667 10.9399 8.43323C10.6816 7.94979 10.3079 7.53754 9.85218 7.23298C9.39642 6.92843 8.87259 6.74097 8.32708 6.68721C7.78157 6.63345 7.23122 6.71505 6.72478 6.92478C6.21833 7.13451 5.77143 7.4659 5.42365 7.8896C5.07587 8.3133 4.83794 8.81622 4.73095 9.35383C4.62395 9.89144 4.65119 10.4471 4.81025 10.9717C4.96931 11.4963 5.25528 11.9735 5.64283 12.3612L7.97616 14.6425L10.3628 12.3558C10.6719 12.0475 10.9168 11.6809 11.0834 11.2773C11.25 10.8737 11.335 10.4411 11.3335 10.0045Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.6631 11.111C9.88287 10.7821 10.0002 10.3954 10.0002 9.99985C10.0002 9.46941 9.78945 8.96071 9.41438 8.58563C9.03931 8.21056 8.5306 7.99985 8.00016 7.99985C7.6046 7.99985 7.21792 8.11715 6.88902 8.33691C6.56012 8.55667 6.30378 8.86903 6.1524 9.23448C6.00103 9.59993 5.96142 10.0021 6.03859 10.39C6.11576 10.778 6.30624 11.1344 6.58595 11.4141C6.86565 11.6938 7.22202 11.8842 7.60998 11.9614C7.99794 12.0386 8.40008 11.999 8.76553 11.8476C9.13098 11.6962 9.44334 11.4399 9.6631 11.111Z",
              fill: "#00973C"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_17546" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { HomeLocationColored };
